import { CACHE_IMAGE, FLUSH_IMAGE } from "./types";

export const cacheImage = (id, thumb, url) => {
  return {
    type: CACHE_IMAGE,
    payload: {
      id: id,
      thumb: thumb,
      url: url
    }
  };
};

export const flushImages = images => dispatch => {
  if (images instanceof Array) {
    images.forEach(i => {
      dispatch({ type: FLUSH_IMAGE, payload: i });
    });
  } else {
    dispatch({ type: FLUSH_IMAGE, payload: images });
  }
};
